import React, { Component } from "react";
import "./NavigationBar.scss";
import * as helpers from "../helpers/helpers";

class NavigationBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showNavigationBar: true,
      visible: true,
      containerClassName: "slidein",
      containerCollapsed: false,
      navLayer: "",
      navigation: "",
    };

    // LISTEN FOR SIDEPANEL CHANGES
    window.emitter.addListener("sidebarChanged", (isSidebarOpen) =>
      this.sidebarChanged(isSidebarOpen)
    );
    // LISTEN FOR CONTROL VISIBILITY CHANGES
    window.emitter.addListener("mapControlsChanged", (control, visible) =>
      this.controlStateChange(control, visible)
    );
  }

  componentDidMount() {
    this.setState({ showNavigationBar: window.mapControls.navbar });
    helpers.waitForLoad("map", Date.now(), 30, () => this.onMapLoad());
  }

  onMapLoad() {
    this.setState({ navLayer: window.config.sourceLayerForNavbar });
    this.onMapMoveEvent = window.map.on("moveend", this.onMapMoveEnd);
    this.getLocation();
  }

  onMapMoveEnd = (evt) => {
    this.getLocation();
  };

  getLocation = () => {
    const zoomValue = Math.round(window.map.getView().getZoom());
    const centerCoords = window.map.getView().values_.center;
    const cql =
      "CONTAINS(geom, Point(" +
      centerCoords[0] +
      " " +
      centerCoords[1] +
      "))&propertyName=nuts1,nuts2,nm2,nm3,nm4,nm5";

    this.getAttributesFromWFS(
      window.config.geoserverUrl,
      this.state.navLayer,
      (result) => {
        // Check if result and features exist
        if (result && result.features && result.features.length !== 0) {
          if (zoomValue <= 2) {
            const spolu = result["features"][0]["properties"]["nuts1"];
            this.setState({
              navigation: spolu,
            });
          } else if (zoomValue === 3) {
            const spolu = result["features"][0]["properties"]["nuts2"];
            this.setState({
              navigation: spolu,
            });
          } else if ((zoomValue === 4) | (zoomValue === 5)) {
            const spolu =
              result["features"][0]["properties"]["nuts2"] +
              " - " +
              result["features"][0]["properties"]["nm2"] +
              " kraj";
            this.setState({
              navigation: spolu,
            });
          } else if ((zoomValue === 6) | (zoomValue === 7)) {
            const spolu =
              result["features"][0]["properties"]["nm2"] +
              " kraj - " +
              result["features"][0]["properties"]["nm3"] +
              " - " +
              result["features"][0]["properties"]["nm4"];
            this.setState({
              navigation: spolu,
            });
          } else if (zoomValue > 7) {
            const spolu =
              result["features"][0]["properties"]["nm2"] +
              " kraj - " +
              result["features"][0]["properties"]["nm3"] +
              " - " +
              result["features"][0]["properties"]["nm4"] +
              " - " +
              result["features"][0]["properties"]["nm5"];
            this.setState({
              navigation: spolu,
            });
          }
        } else {
          this.setState({
            navigation: "",
          });
        }
      },
      null,
      null,
      cql,
      "1"
    );
  };


  getAttributesFromWFS = (
    serverUrl,
    layerName,
    callback,
    sortField = null,
    extent = null,
    cqlFilter = null,
    count = null
  ) => {
    // SORTING
    let additionalParams = "";
    if (sortField !== null) additionalParams += "&sortBy=" + sortField;

    // BBOX EXTENT
    if (extent !== null && (cqlFilter === null || cqlFilter.length === 0)) {
      const extentString =
        extent[0] + "," + extent[1] + "," + extent[2] + "," + extent[3];
      additionalParams += "&bbox=" + extentString;
    }

    // ATTRIBUTE WHERECLAUSE
    if (cqlFilter !== null && cqlFilter.length !== 0) {
      additionalParams += "&cql_filter=" + cqlFilter;
      if (extent !== null) {
        const extentString =
          extent[0] + "," + extent[1] + "," + extent[2] + "," + extent[3];
        additionalParams += " AND BBOX(geom, " + extentString + ")";
      }
    }
    // COUNT
    if (count !== null) additionalParams += "&count=" + count;

    // USE TEMPLATE FOR READABILITY
    const wfsUrlTemplate = (serverURL, layerName) =>
      `${serverURL}wfs?service=wfs&version=2.0.0&request=GetFeature&typeNames=${layerName}&outputFormat=application/json`;
    const wfsUrl = wfsUrlTemplate(serverUrl, layerName) + additionalParams;

    return fetch(wfsUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((jsonResponse) => {
        if (callback !== undefined) callback(jsonResponse, null);  // Added null as the second parameter to indicate no error
      })
      .catch((error) => {
        if (error.message.includes("Failed to fetch")) {
          console.error("Fetch failed. Possible CORS or network issue.", wfsUrl, error);
        } else {
          console.error(wfsUrl, error);
        }
        if (callback !== undefined) callback(null, error);  // Pass the error as the second parameter
      });
  };

  // HANDLE SIDEBAR CHANGES
  sidebarChanged(isSidebarOpen) {
    //  SIDEBAR IN AND OUT
    if (isSidebarOpen) {
      this.setState({
        containerClassName: "slideout",
      });
    } else {
      this.setState({
        containerClassName: "slidein",
      });
    }
  }

  onCollapsedClick = (evt) => {
    // HIDE OPEN PANELS
    if (this.state.containerCollapsed === false) {
      this.setState({ copyrightPanelOpen: false });
    }
    this.setState({ containerCollapsed: !this.state.containerCollapsed });
  };

  render() {
    return (
      <div className={!this.state.showNavigationBar ? " sc-hidden" : ""}>
        <div
          id="navigationBar-container"
          className={this.state.containerClassName}
        >
          <div
            id="copyright-collapse-button"
            className={
              this.state.containerCollapsed
                ? "copyright-collapse-button closed"
                : "copyright-collapse-button"
            }
            onClick={this.onCollapsedClick}
          />
          <div
            className={
              this.state.containerCollapsed ? "copyright-hidden" : "copyright"
            }
          >
            {this.state.navigation}
          </div>
        </div>
      </div>
    );
  }
}

export default NavigationBar;
